// Tema "sistema" de SyncLyst (decision de Arturo): sin eleccion guardada, light de 6:00 a 17:59 y
// dark de 18:00 a 5:59 (hora local del navegador). Igual en synclyst.com y synclyst.mx.
// index.html replica esta regla inline (corre antes de React): si cambias las horas, cambia ambas.
export const THEME_LIGHT_FROM_HOUR = 6;
export const THEME_DARK_FROM_HOUR = 18;

export function timeBasedTheme(now: Date = new Date()): 'light' | 'dark' {
  const h = now.getHours();
  return h >= THEME_LIGHT_FROM_HOUR && h < THEME_DARK_FROM_HOUR ? 'light' : 'dark';
}

/** Lee la eleccion explicita (Settings) si es light|dark; 'system' o nada -> null. */
export function storedThemeChoice(): 'light' | 'dark' | null {
  try {
    const v = typeof window !== 'undefined' ? window.localStorage.getItem('theme_user_choice') : null;
    return v === 'light' || v === 'dark' ? v : null;
  } catch {
    return null;
  }
}
